const state = {
    position:'',
    isLoading: false,
    isGuest: false,
    direction: 'forward',
    userInfo: {},
    data:'',
    initialize: '',
    comment: false,
    _url: '',
    _menu:'',
    cartNum:'',
    msgNum:'',
    postcode:'',
    leader:'',
    leader_emp:'',
    device:{'cordova':'','model':'','platform':'','uuid':'test','version':'','manufacturer':'','isVirtual':'','serial':''},
}
export default state
